// Step 4 — tickets printing. Determinate progress + "{done} of {total}".

import { PrinterWithTicket } from "../components/Illustrations";
import { KioskShell } from "../components/KioskShell";
import { ProgressBar } from "../components/ProgressBar";
import { useLang } from "../i18n/LangContext";
import type { KioskState } from "../state/types";

type Printing = Extract<KioskState, { phase: "printing" }>;

export function PrintingScreen({ state }: { state: Printing }) {
  const { t } = useLang();
  const total = state.tickets.length;
  const done = Math.min(state.printedCount, total);
  const pct = total === 0 ? 100 : (done / total) * 100;
  return (
    <KioskShell step={4}>
      <div className="screen screen--center">
        <div className="illustration">
          <PrinterWithTicket />
        </div>
        <h1 className="screen__title">{t("printingTitle")}</h1>
        <span className="chip chip--amount">
          {t("printingProgress", { done, total })}
        </span>
        <ProgressBar value={pct} />
        <p className="screen__note">{t("printingWait")}</p>
      </div>
    </KioskShell>
  );
}
